import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
    paper: {
        paddingTop: `var(--safe-area-inset-top)`,
        paddingBottom: `var(--safe-area-inset-bottom)`,
        paddingLeft: `var(--safe-area-inset-left)`,
        paddingRight: `var(--safe-area-inset-right)`,
      }
}));